import { render, staticRenderFns } from "./CodeTags.vue?vue&type=template&id=3f258306&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CodeTags.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/CodeTags.vue
// module id = 1702
// module chunks = 1